"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSelectedMediaModelWidget = getSelectedMediaModelWidget;
// import { isWidget } from '@ckeditor/ckeditor5-widget/src/utils'

// export function isMediaWidget(viewElement) {
//   console.log('viewElement----', viewElement)
//   if (!viewElement) return false
//   return !!viewElement.getCustomProperty('media') && isWidget(viewElement)
// }

// export function isMediaWidget(modelElement) {
//   console.log('modelElement----', modelElement)
//   return modelElement && modelElement.is('media')
// }

function getSelectedMediaModelWidget(selection) {
  var selectedElement = selection.getSelectedElement();

  // console.log('selectedElement----', selectedElement)
  if (selectedElement && selectedElement.is('media')) {
    return selectedElement;
  }
  return null;
}